(() => {
  const RATIO_HEIGHT = 474;
  const RATIO_WIDTH = 375;

  function isMobile() {
    return window.matchMedia('(max-width: 786px)').matches;
  }

  function setImportant(el, prop, value) {
    if (!el || !el.style) return;
    el.style.setProperty(prop, value, 'important');
  }

  function fixBannerGap() {
    if (!isMobile()) return;

    const bannerHeight = `${Math.round(window.innerWidth * RATIO_HEIGHT / RATIO_WIDTH)}px`;
    const banners = document.querySelectorAll('.alp-index-banner-wrapper, [data-stid].alp-index-banner-wrapper');

    banners.forEach((banner) => {
      setImportant(banner, 'height', bannerHeight);
      setImportant(banner, 'min-height', '0');
      setImportant(banner, 'max-height', 'none');
      setImportant(banner, 'padding-bottom', '0');
      setImportant(banner, 'margin-bottom', '0');
      setImportant(banner, 'overflow', 'hidden');

      banner.querySelectorAll('.full-img-wrap, .swiper, .swiper-wrapper, .swiper-slide, .alp-index-banner-bg, picture').forEach((node) => {
        setImportant(node, 'height', '100%');
      });

      banner.querySelectorAll('img').forEach((image) => {
        setImportant(image, 'height', '100%');
        setImportant(image, 'object-fit', 'cover');
        setImportant(image, 'object-position', 'center top');
      });
    });

    document.querySelectorAll('.alp-product-tabs').forEach((section) => {
      setImportant(section, 'padding-top', '18px');
    });
  }

  function boot() {
    fixBannerGap();
    requestAnimationFrame(fixBannerGap);
    setTimeout(fixBannerGap, 100);
    setTimeout(fixBannerGap, 500);
    setTimeout(fixBannerGap, 1200);

    window.addEventListener('resize', fixBannerGap, { passive: true });
    document.addEventListener('shopify:section:load', fixBannerGap);
    document.addEventListener('shopify:section:select', fixBannerGap);

    if ('MutationObserver' in window && document.body) {
      const observer = new MutationObserver(fixBannerGap);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
